import Vue from 'vue'
import { resolveResPath } from '~/utils'

export default ({ app, $config }, inject) => {
  // 把$config挂载到工具方法的this上
  Vue.filter('resPath', resolveResPath.bind({ $config }));
}